import type { SignUpFormValues } from '../schemas';

import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';

import { OwnerType } from '../models/enums';
import { signUpFormSchema } from '../schemas';

export const defaultValues: SignUpFormValues = {
  type: '',
  email: '',
  agreedOnTerms: false,

  isEmployee: false,
  ownerType: OwnerType.BUSINESS,

  structure: '',
  abn: '',

  businessName: '',
  roleInBusiness: '',

  companyName: '',
  acn: '',
  roleInCompany: '',

  trustName: '',
  trustType: '',

  firstName: '',
  lastName: '',
  mobile: '',
  password: '',

  oneTimeCode: '',

  inviterName: '',
  inviteeEmail: '',
};

export const useSignUpForm = () => {
  return useForm({
    mode: 'all',
    defaultValues,
    resolver: zodResolver(signUpFormSchema),
  });
};
